import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getRecipientWireDetailsPath = (id: string = ':id') => urlHelper(`/recipient/wire/${id}/details`);
